// Cash
import enApproved from 'i18n/locales/en/cash/approved.json';
import enBulkActions from 'i18n/locales/en/cash/bulk-actions.json';
import enCash from 'i18n/locales/en/cash/cash.json';
import enReconciliation from 'i18n/locales/en/cash/reconciliation.json';
import enMatch from 'i18n/locales/en/cash/reconciliation/for-review/match.json';
import enNoMatch from 'i18n/locales/en/cash/reconciliation/for-review/no-match/no-match.json';
import enReporting from 'i18n/locales/en/cash/reporting.json';
import enVisualizations from 'i18n/locales/en/cash/visualizations.json';
import enCloseOverview from 'i18n/locales/en/close-overview/close-overview.json';
// Common
import enCommon from 'i18n/locales/en/common.json';
// Expense and AP
import enConsolidationChartOfAccounts from 'i18n/locales/en/consolidation/chart-of-accounts.json';
import enConsolidationCommon from 'i18n/locales/en/consolidation/common.json';
import enConsolidationConsolidationGroups from 'i18n/locales/en/consolidation/consolidation-groups.json';
import enConsolidationIntercompanySets from 'i18n/locales/en/consolidation/intercompany-sets.json';
import enExpenseAndApAccountingWork from 'i18n/locales/en/expense-and-ap/accounting-work.json';
import enExpenseAndApBillAnalysis from 'i18n/locales/en/expense-and-ap/bill-analysis.json';
import enExpenseAndAp from 'i18n/locales/en/expense-and-ap/expense-and-ap.json';
// Fixed Assets
import enFixedAssets from 'i18n/locales/en/fixed-assets/fixed-assets.json';
// Flux Analyses
import enFluxAnalyses from 'i18n/locales/en/flux-analyses/flux-analyses.json';
// Integrations
import enIntegrations from 'i18n/locales/en/integrations/integrations.json';
// Intercompany Elimination
import enIntercompanyElimination from 'i18n/locales/en/intercompany-elimination/intercompany-elimination.json';
// Login
import enLogin from 'i18n/locales/en/login/login.json';
// Mapping
import enMapping from 'i18n/locales/en/mapping/mapping.json';
import enMonitoring from 'i18n/locales/en/monitoring.json';
// Period Close
import enCloseChecklist from 'i18n/locales/en/period-close/close-checklist.json';
import enReconciliations from 'i18n/locales/en/period-close/reconciliations.json';
// Privacy Policy
import enPrivacyPolicy from 'i18n/locales/en/privacy-policy.json';
// Reports
import enReportsCommon from 'i18n/locales/en/reports/common.json';
import enReportsHub from 'i18n/locales/en/reports/reports-hub/reports-hub.json';
import enReports from 'i18n/locales/en/reports/reports.json';
// Revenue
import enRevenueCalculations from 'i18n/locales/en/revenue/calculations/calculations.json';
import enRevenueCommon from 'i18n/locales/en/revenue/common.json';
import enRevenueContract from 'i18n/locales/en/revenue/contract/contract.json';
import enRevenueInvoice from 'i18n/locales/en/revenue/invoice/invoice.json';
import enRevenueJournalEntries from 'i18n/locales/en/revenue/journal-entries/journal-entries.json';
import enRevenueOverview from 'i18n/locales/en/revenue/overview/overview.json';
import enRevenueReports from 'i18n/locales/en/revenue/reports/reports.json';
import enRevenueRevenueRecognition from 'i18n/locales/en/revenue/revenue-recognition/revenue-recognition.json';
import enRevenueShared from 'i18n/locales/en/revenue/shared/shared.json';
import enRevenueSsp from 'i18n/locales/en/revenue/ssp/ssp.json';
// Run Time
import enRunTime from 'i18n/locales/en/run-time/run-time.json';
// Settings
import enSettingsCompanyStructure from 'i18n/locales/en/settings/company-structure.json';
import enSettingsOrganisationInfo from 'i18n/locales/en/settings/organisation-info.json';
import enSettingsUserManagement from 'i18n/locales/en/settings/user-management.json';
// Term of Service
import enTermOfService from 'i18n/locales/en/term-of-service.json';

export const resources = {
  en: {
    // Cash
    'cash/no-match': enNoMatch,
    'cash/match': enMatch,
    'cash/approved': enApproved,
    'cash/reconciliation': enReconciliation,
    'cash/bulk-actions': enBulkActions,
    'cash/visualizations': enVisualizations,
    'cash/reporting': enReporting,
    cash: enCash,
    // Close Insights
    'close-overview': enCloseOverview,
    // Common
    common: enCommon,
    // Integrations
    integrations: enIntegrations,
    // Revenue
    'revenue/common': enRevenueCommon,
    'revenue/contract': enRevenueContract,
    'revenue/invoice': enRevenueInvoice,
    'revenue/reports': enRevenueReports,
    'revenue/revenue-recognition': enRevenueRevenueRecognition,
    'revenue/journal-entries': enRevenueJournalEntries,
    'revenue/calculations': enRevenueCalculations,
    'revenue/ssp': enRevenueSsp,
    'revenue/shared': enRevenueShared,
    'revenue/overview': enRevenueOverview,
    // Login
    login: enLogin,
    // Run Time
    'run-time': enRunTime,
    // Term of Service
    'privacy-policy': enPrivacyPolicy,
    'term-of-service': enTermOfService,
    // Settings
    'settings/company-structure': enSettingsCompanyStructure,
    'settings/organisation-info': enSettingsOrganisationInfo,
    'settings/user-management': enSettingsUserManagement,
    // Intercompany Elimination
    'intercompany-elimination': enIntercompanyElimination,
    // Flux Analyses
    'flux-analyses': enFluxAnalyses,
    // Reports
    reports: enReports,
    'reports/reports-hub': enReportsHub,
    'reports/common': enReportsCommon,
    // Fixed Assets
    'fixed-assets': enFixedAssets,
    'expense-and-ap': enExpenseAndAp,
    'expense-and-ap/accounting-work': enExpenseAndApAccountingWork,
    'expense-and-ap/bill-analysis': enExpenseAndApBillAnalysis,
    'close-checklist': enCloseChecklist,
    reconciliations: enReconciliations,
    'consolidation/chart-of-accounts': enConsolidationChartOfAccounts,
    'consolidation/consolidation-groups': enConsolidationConsolidationGroups,
    'consolidation/intercompany-sets': enConsolidationIntercompanySets,
    'consolidation/common': enConsolidationCommon,
    // Monitoring
    monitoring: enMonitoring,
    // Mapping
    'mapping/mapping': enMapping,
  },
};
